<template>
    <div class="row">
        <div class="col-12">
            <div class="card" id="seating-header">
                <div class="card-header p-0">
                    <h1 class="card-title">
                        Choisissez vos sièges
                    </h1>
                </div>
                <div class="card-body card-body-home p-4">
                    <div class="row">
                        <div class="col-8">
                            <div>{{ this.get_event_start_date(this.$root.current_event.start_event) }}</div>
                            <div>{{ this.$root.current_event.name }}</div>
                        </div>
                        <div class="col-4 text-center">
                            <div class="color-secondary fs-22 text-uppercase">{{ this.trans.get('kiosk.number-ticket',{'val': this.$root.cartItemsCount()}) }}</div>
                            <div class="seating-stotal">{{ this.$root.getSubTotal() }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <div id="seating-item-block" class="card-body p-4">
                <div class="row ms-3 me-3 pb-3 pt-3">
                    <div class="col-5"></div>
                    <div class="col-4 text-center fw-bold text-uppercase">Siège</div>
                    <div class="col-3 text-center fw-bold text-uppercase">Sélectionnez pour modifier</div>
                </div>
                <div class="col-12" id="seating-item-item" show_swipe_up_down="" onscroll="$(this).find('.scroll_info').remove()">
                    <seatingItem-component
                        v-for="(cartItem, idx,index) in this.$root.cart_products_seating_chart"
                        :ref="'seating_items_'+index"
                        v-bind:cartItem="cartItem"
                        v-bind:idx="idx"
                        v-bind:index="index"
                        v-bind:nb="Object.keys(this.$root.cart_products_seating_chart).length"
                        v-bind:place="this.place[idx]"
                    />
                    <div class="scroll_info">
                        <div class="scroll_info_hover" onmouseover="$(this).parent().remove();"></div>
                        <object data="/assets/kiosk/img/scroll-borne.svg"></object>
                    </div>
                </div>
            </div>
        </div>
    </div>



    <div class="row mt-5">

        <div class="canvas position-relative" >
            <!--div id="seating-chart-info" v-show="this.show_info">
                <div class="seating-chart-info-hover" @click="this.show_info = false;"></div>
                <div class="d-flex full-height justify-content-center flex-column">
                    <div class="seating-chart-info-close"><i class="far fa-times"></i></div>
                    <div class="row mb-2">
                        <div class="col-12 text-center"><i class="far fa-info-circle"></i> Instructions</div>
                    </div>
                    <div class="row">
                        <div class="col-6 ps-5 pe-5">
                            <object data="/assets/kiosk/img/clic-borne.svg"></object>
                            <div class="text-center">Double-clic pour ouvrir une <u>section</u></div>
                        </div>
                        <div class="col-6 ps-5 pe-5">
                            <object data="/assets/kiosk/img/zoom-borne.svg"></object>
                            <div class="text-center">Deux doigts pour <u>zoomer</u></div>
                        </div>
                    </div>
                </div>
            </div-->
            <div class = "seating_chart_controller_show"
                v-bind:class="{ 'd-none': controller_is_actif }"
            >
                <div class="w-100 h-100">
                    <button
                    v-on:click="controller_is_actif = true"
                    class = "btn btn-seating_chart-light-blue btn-fullsize">
                        <i class="far fa-arrows-alt fa-lg fa-fw"></i>
                    </button>

                </div>
            </div>
            <div class = "seating_chart_controller"
                v-bind:class="{ 'd-none': !controller_is_actif }"
                >
                <div class="ratio-1x1 p-0" id = "arrow_direction_section">
                    <div class="w-100 h-33 d-flex flex-row" id = "arrow_top_section">
                        <div class="w-33 h-100" id = "arrow_top_left_section">
                        <button
                            v-on:click="this.ZoomSeatingChart(1)"

                            class = "btn btn-seating_chart-light-blue btn-fullsize">
                            <i class="far fa-search-plus fa-lg fa-fw"></i>
                        </button>
                        </div>
                        <div class="w-33 h-100" id = "arrow_top_middle_section">
                            <button
                            v-on:click="this.MoveSeatingChart(0,1)"
                            class = "btn btn-seating_chart-light-blue btn-fullsize">
                                <i class="fas fa-arrow-up fa-lg fa-fw"></i>
                            </button>
                        </div>
                        <div class="w-33 h-100" id = "arrow_top_right_section">
                            <button
                            v-on:click="controller_is_actif = false"
                            class = "btn btn-seating_chart-light-blue btn-fullsize">
                                <i class="far fa-times fa-lg fa-fw"></i>
                            </button>

                        </div>
                    </div>
                    <div class="w-100 h-33 d-flex flex-row" id = "arrow_center_section">
                        <div class="w-33 h-100" id = "arrow_center_left_section">
                            <button
                                v-on:click="this.MoveSeatingChart(1,0)"
                                class = "btn btn-seating_chart-light-blue btn-fullsize">
                                <i class="fas fa-arrow-left fa-lg fa-fw"></i>
                            </button>
                        </div>
                        <div class="w-33 h-100" id = "arrow_center_middle_section">
                            <button
                            v-on:click="this.ResetZoomSeatingChart()"
                            class = "btn btn-seating_chart-light-blue btn-fullsize">
                                <i class="far fa-undo-alt fa-lg fa-fw"></i>
                            </button>
                        </div>
                        <div class="w-33 h-100" id = "arrow_center_right_section">
                            <button
                                v-on:click="this.MoveSeatingChart(-1,0)"
                                class = "btn btn-seating_chart-light-blue btn-fullsize">
                                <i class="fas fa-arrow-right fa-lg fa-fw"></i>
                            </button>
                        </div>
                    </div>
                    <div class="w-100 h-33 d-flex flex-row" id = "arrow_bottom_section">
                        <div class="w-33 h-100" id = "arrow_bottom_left_section">
                            <button
                            v-on:click="this.ZoomSeatingChart(-1)"
                            class = "btn btn-seating_chart-light-blue btn-fullsize">
                                <i class="far fa-search-minus fa-lg fa-fw"></i>
                            </button>
                        </div>
                        <div class="w-33 h-100" id = "arrow_bottom_middle_section">
                            <button
                                v-on:click="this.MoveSeatingChart(0,-1)"
                                class = "btn btn-seating_chart-light-blue btn-fullsize">
                                <i class="fas fa-arrow-down fa-lg fa-fw"></i>
                            </button>
                        </div>
                        <div class="w-33 h-100" id = "arrow_bottom_right_section">
                        </div>
                    </div>
                </div>
            </div>
            <div id="global_gl_canvas">
                <canvas id="gl_canvas"></canvas>
            </div>
            <div id="global_warning">
                <div id="warning_holder" class="disable">
                    <div class="windows">
                        <div class="header">
                            <h2>
                                <i class="far fa-exclamation-circle"></i>
                                Avertissement
                                <i class="far fa-exclamation-circle"></i>
                            </h2>
                        </div>
                        <br>
                        <div class="warning_message">
                            This is a Default warning Message
                        </div>
                        <br>
                        <div class="button_list">
                            <button class="btn btn-rounded  btn-warning" id="warning_popup_button_0">OK</button>
                            <button class="btn btn-rounded  btn-primary" id="warning_popup_button_1">YES</button>
                            <button class="btn btn-rounded  btn-danger"  id="warning_popup_button_2">No</button>
                            <button class="btn btn-rounded  btn-warning" id="warning_popup_button_3">Cancel</button>
                            <button class="btn btn-rounded  btn-warning" id="warning_popup_button_4">Retry</button>
                            <button class="btn btn-rounded  btn-warning" id="warning_popup_button_5">Next</button>
                        </div>
                    </div>
                </div>
            </div>
            <div id="global_usefull">
                <div id="loading_holder">
                    <div class="loading_principal_information">
                        <span>LOADING IN PROGRESS..... PLEASE WAIT</span>
                    </div>
                    <div class="Loading_current_information">
                        <span></span>
                    </div>
                </div>
            </div>
        </div>
    </div>


</template>

<script>
import SeatingItem from "./SeatingItem";
import {callAPI, formatTimeStamp, isset} from "../../helpers/kiosk-helpers";

export default {
    name: "SeatingChartComponent",

    components: {
        'seatingItem-component': SeatingItem,
    },

    created() {
        this.place = this.$root.seating_place_info;

        this.getSeartingChartUID()
            .then(response => {
                this.init();
                this.seating_chart_scripts_are_loaded = this.$root.seating_chart_scripts_are_loaded;
                if (this.seating_chart_scripts_are_loaded === false) {
                    this.loadSeatingChartScripts();
                }

            })
            .catch(error => {
                this.$root.addErrors(error,null,String(error));
            });

    },
    mounted() {
        this.seating_mounted = true;
        setTimeout(this.valid_next_btn,500);
        this.$root.scrollbarVisible();
    },

    data() {
        return {
            loaded_seating_chart_scripts_count: 0,
            if_seating_item_is_loaded: false,
            m_cart_items_infos: [],
            m_seating_chart_uid: "",
            seat_to_place: [],
            seating_mounted: false,
            seating_chart_scripts_are_loaded: false,
            place: [],
            controller_is_actif : true,
            show_info: true,
            event_id: null,
            product_id: null,

        }
    },
    watch: {
        if_seating_item_is_loaded(value){
            if(value === true){
                this.valid_loading_chart();
            }
        },
        seating_mounted(value){
            if(value === true){
                this.valid_loading_chart();
            }
        },
        seating_chart_scripts_are_loaded(value){
            if(value === true){
                this.$root.seating_chart_scripts_are_loaded = true;
                this.valid_loading_chart();
            }
        },
    },





    methods: {

        getSeartingChartUID()
        {
            let products = this.$root.cart_products_seating_chart;

            for (const [key, value] of Object.entries(products)) {
                if(products[key]['features'] !== undefined && products[key]['features']['FEATURE_EVENT_INFOS'] !== undefined && products[key]['features']['FEATURE_EVENT_INFOS']['FEATURE_EVENT_UID'] !== undefined)
                {
                    this.event_id = products[key]['features']['FEATURE_EVENT_INFOS']['FEATURE_EVENT_UID'];
                    this.product_id = products[key]['idx'];
                    break;
                }
            }

            return new window.Promise((resolve, reject) => {

                if(this.product_id === null || this.event_id === null)
                {
                    this.$root.has_seating_chart = false;
                    resolve('ok');
                    this.$router.push({ name: this.$root.locale + '.summary' });
                    //reject('a-205');
                }

                let data = {};
                data['product_id'] = this.product_id;
                data['event_id'] = this.event_id;

                callAPI(route('api.kiosk.get.seating.chart.uid'),{ data: data }, 'post')
                    .then(response => {

                        console.log(response);

                        if(response['data']['success'] === 1)
                        {
                            this.m_seating_chart_uid = response['data']['seating_chart_info']['data']['standard_information']['uid'];
                            this.$root.has_seating_chart = true;
                        }
                        else {
                            reject('error');
                        }

                        resolve(response);


                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        valid_loading_chart()
        {
            if(this.seating_mounted === true && this.if_seating_item_is_loaded === true && this.$root.seating_chart_scripts_are_loaded === true &&  this.seating_chart_scripts_are_loaded === true) {
                this.initSeatingChart();
            }
        },

        updateCartItem(cartItem)
        {
            this.m_cart_items_infos.push(cartItem);
        },
        updateSeatToPlace(action, index)
        {
            if(action === 'remove')
            {
                var index2 = this.seat_to_place.indexOf(index);
                if (index2 !== -1) {
                    this.seat_to_place.splice(index2, 1);
                }

                if(Object.keys(window.seating_chart_info).length !== 0) {
                    this.UpdateSeatingChartInfo(window.seating_chart_info['seating_chart_app'], this.seat_to_place);
                }
            }

            if(action === 'add')
            {
                //this.seat_to_place[index] = index;

                var index2 = this.seat_to_place.indexOf(index);
                if (index2 === -1) {
                    this.seat_to_place.push(index);
                }



                if(Object.keys(window.seating_chart_info).length !== 0) {
                    this.UpdateSeatingChartInfo(window.seating_chart_info['seating_chart_app'], this.seat_to_place);
                }
            }

        },
        get_event_start_date(timestamp)
        {
            return formatTimeStamp(timestamp);
        },
        loadSeatingChartScripts()
        {

            let scripts = [
            "https://api3.xpayrience.com/v1.0/js/api.js",

            "https://xplore3.xpayrience.com/js/pixi-legacy.min.js",
            "https://xplore3.xpayrience.com/js/menu_functions.js",

            "https://xplore3.xpayrience.com/js/warning_popup.js",
            "https://xplore3.xpayrience.com/js/event.js",

            "https://xplore3.xpayrience.com/js/ticket_editor_ui_manager.js",

            //toolfile
            "https://xplore3.xpayrience.com/js/ToolFiles/ClGlobals.js",
            "https://xplore3.xpayrience.com/js/ToolFiles/ClMathFunction.js",
            "https://xplore3.xpayrience.com/js/ToolFiles/ClToolBox.js",

            //Handler
            "https://xplore3.xpayrience.com/js/Handler/ClBaseHandler.js",
            "https://xplore3.xpayrience.com/js/Handler/ClApiDBCallHandler.js",
            "https://xplore3.xpayrience.com/js/Handler/ClLODSystemHandler.js",
            "https://xplore3.xpayrience.com/js/Handler/ClModeExtensionsHandler.js",

            "https://xplore3.xpayrience.com/js/Handler/CameraHandler/ClCameraHandler.js",

            "https://xplore3.xpayrience.com/js/Handler/InputHandler/ClDragHandler.js",
            "https://xplore3.xpayrience.com/js/Handler/InputHandler/ClKeyHandler.js",
            "https://xplore3.xpayrience.com/js/Handler/InputHandler/ClMouseHandler.js",

            "https://xplore3.xpayrience.com/js/Handler/SaveHandler/ClLoadRoomHandler.js",

            "https://xplore3.xpayrience.com/js/Handler/SelectionHandler/ClSelectionHandler.js",

            "https://xplore3.xpayrience.com/js/Handler/UIHandler/PopupHandler/ClLoadingPopupHandler.js",
            "https://xplore3.xpayrience.com/js/Handler/UIHandler/WindowHandler/ClWindowMenuHandler.js",

            "https://xplore3.xpayrience.com/js/SceneObject/ClSceneElement.js",
            "https://xplore3.xpayrience.com/js/SceneObject/ClSceneElementType.js",
            "https://xplore3.xpayrience.com/js/Ticket/ClTicketGroup.js",
            "https://xplore3.xpayrience.com/js/ClSettings.js",

            "https://xplore3.xpayrience.com/js/Component/ClComponent.js",
            "https://xplore3.xpayrience.com/js/Component/ClTicketGroupComponent.js",
            "https://xplore3.xpayrience.com/js/Component/ClSeatComponent.js",
            "https://xplore3.xpayrience.com/js/Component/ClFloorAreaComponent.js",
            "https://xplore3.xpayrience.com/js/Component/ClAreaComponent.js",
            "https://xplore3.xpayrience.com/js/Component/ClTableComponent.js",
            "https://xplore3.xpayrience.com/js/Component/ClTextComponent.js",

            "https://xplore3.xpayrience.com/js/RenderElement/ClRenderElement.js",
            "https://xplore3.xpayrience.com/js/RenderElement/ClGraphicRenderElement.js",
            "https://xplore3.xpayrience.com/js/RenderElement/ClCircleRenderElement.js",
            "https://xplore3.xpayrience.com/js/RenderElement/ClAngleCircleRenderElement.js",
            "https://xplore3.xpayrience.com/js/RenderElement/ClCustomGraphRenderElement.js",
            "https://xplore3.xpayrience.com/js/RenderElement/ClEmptyRenderElement.js",
            "https://xplore3.xpayrience.com/js/RenderElement/ClRectangleRenderElement.js",
            "https://xplore3.xpayrience.com/js/RenderElement/ClSpriteRenderElement.js",
            "https://xplore3.xpayrience.com/js/RenderElement/ClTextRenderElement.js",
            "https://xplore3.xpayrience.com/js/RenderElement/ClLineRenderElement.js",



            "https://xplore3.xpayrience.com/js/ModeExtensions/ClModeBase.js",
            "https://xplore3.xpayrience.com/js/ModeExtensions/ClModeDefault.js",
            "https://xplore3.xpayrience.com/js/ModeExtensions/ClModeUser.js",
            "https://xplore3.xpayrience.com/js/LayerExtensions/ClBackgroundLayer.js",
            "https://xplore3.xpayrience.com/js/LayerExtensions/ClElementsLayer.js",
            "https://xplore3.xpayrience.com/js/LayerExtensions/ClZoneLayer.js",
            "https://xplore3.xpayrience.com/js/LayerExtensions/ClStageLayer.js",
            "https://xplore3.xpayrience.com/js/ClSeatingChart.js",

            ];
            this.loadScript(scripts,0);

        },
        loadScript(p_scripts,p_current_script_id)
        {
            let script;
            script = document.createElement('script');
            script.setAttribute('src', p_scripts[p_current_script_id]);
            script.onload = () =>
            {
                this.loaded_seating_chart_scripts_count++;

                if(this.loaded_seating_chart_scripts_count === p_scripts.length)
                {
                    this.seating_chart_scripts_are_loaded = true;
                }
                else
                {
                    this.loadScript(p_scripts,p_current_script_id+1);
                }
            }
            document.head.appendChild(script);
        },
        initSeatingChart()
        {
            let seating_chart_app = this.CreatePixiApp();
            this.UpdateSeatingChartInfo(seating_chart_app,this.seat_to_place);
            window.seating_chart_info['seating_chart_app'] = seating_chart_app;

        },
        CreatePixiApp()
        {
            let ratio = 4050 / 2449;
            let lew = document.getElementById('global_gl_canvas').clientWidth;
            let leh = lew / ratio;
            //yes it's hardcodded for now
            let available_size = {
                x: lew,
                y: leh,
            };
            //i could hardcode the size

            //copy the cart_item_info because proxy stuff is really anoying
            let cart_items_infos = JSON.parse(JSON.stringify(this.m_cart_items_infos));

            let tempo = {
                m_is_user_mode : true,
                m_element_id : "gl_canvas",
                m_seating_chart_uid : this.m_seating_chart_uid,
                m_store_id : window.localStorage.getItem('xpayrience_store_id'),
                m_event_id : 1,
                m_bg_color : 0xFFFFFF,
                m_cart_items_infos : cart_items_infos,
                m_auth_tokens: window.api_auth_tokens,
                m_width:  available_size.x,
                m_height:  available_size.y,
            };

            let seating_chart = new ClSeatingChart(tempo);
            seating_chart.run();
            return seating_chart;

        },
        UpdateSeatInfo()
        {
            let i = 0;
            for(i = 0; i < window.seating_chart_info['seating_chart_app'].m_cart_items_infos.length; i++ )
            {
                if(isset(window.seating_chart_info['seating_chart_app'].m_cart_items_infos[i].m_scene_element)) {
                    let seatinfo = window.seating_chart_info['seating_chart_app'].m_cart_items_infos[i].m_scene_element.m_components["ClSeatComponent"].GetInformationForCart();
                    let databaseUID = window.seating_chart_info['seating_chart_app'].m_cart_items_infos[i].m_scene_element.m_database_uid;
                    let idx = this.m_cart_items_infos[i].m_uid;

                    this.updateSeatingInfo(idx, databaseUID, seatinfo.parent_name, seatinfo.row_name, seatinfo.seat_name);
                }
            }
            for(i = 0; i < window.seating_chart_info['seating_chart_app'].m_cart_items_infos.length; i++ )
            {
                //debugger
                if(!isset(window.seating_chart_info['seating_chart_app'].m_cart_items_infos[i].m_scene_element)) {

                    this.seat_to_place = [i];
                    this.UpdateSeatingItemSelected(window.seating_chart_info['seating_chart_app'],[i])
                    this.UpdateSeatingChartInfo(window.seating_chart_info['seating_chart_app'],[i]);
                    return;
                }
            }
        },
        UpdateSeatingItemSelected(p_seating_chart,p_array_element_selected)
        {
            let childs  = this.$refs;
            let keys  = Object.keys(childs);

            for(let i = 0 ; i<keys.length;++i)
            {
                if(p_array_element_selected.includes(childs[keys[i]][0].index))
                {
                    childs[keys[i]][0].selected = true;
                }
                else
                {
                    childs[keys[i]][0].selected = false;
                }
            }


        },
        updateSeatingInfo(idx,databaseUID,section,row,seat)
        {
            this.place[idx] = [];
            this.place[idx]['databaseUID'] = databaseUID;
            this.place[idx]['section'] = section;
            this.place[idx]['row'] = row;
            this.place[idx]['seat'] = seat;
            /* 30 min */
            //this.place[idx]['time_end'] = new Date().getTime() + (30 * 60000);
            //this.place[idx]['time_end'] = new Date().getTime() + (6000);


            this.valid_next_btn();

        },
        UpdateSeatingChartInfo(p_seating_chart, p_cart_items_id = [])
        {
            //force the seating_chart in covid mode
            p_seating_chart.is_open = true;

            //wait for the seating_chart to be ready
            if(!p_seating_chart.m_load_room_handler.AskIfReadyToOpen(()=>{this.UpdateSeatingChartInfo(p_seating_chart,p_cart_items_id)}))
            {
                return
            }

            let cart_items_id = JSON.parse(JSON.stringify(p_cart_items_id));

            //here we get the list of product we are currently looking for
            let product_we_are_looking_for = [];
            let amount_of_seat_we_are_looking_for = p_seating_chart.m_cart_items_infos.length;
            let allSideBySide = cart_items_id.length < 1 ? true:false;
            if(allSideBySide)
            {
                for(let i = 0 ; i < amount_of_seat_we_are_looking_for;++i)
                {
                    if(product_we_are_looking_for.indexOf(p_seating_chart.m_cart_items_infos[i].m_product_id) == -1)
                    {
                        product_we_are_looking_for.push(p_seating_chart.m_cart_items_infos[i].m_product_id);
                    }
                }
            }
            else
            {
                amount_of_seat_we_are_looking_for = cart_items_id.length;

                for(let i = 0 ; i < amount_of_seat_we_are_looking_for;++i)
                {
                    if(product_we_are_looking_for.indexOf(p_seating_chart.m_cart_items_infos[cart_items_id[i]].m_product_id) == -1)
                    {
                        product_we_are_looking_for.push(p_seating_chart.m_cart_items_infos[cart_items_id[i]].m_product_id);
                    }
                }
            }


            let carts_ids_used = [];
            if(allSideBySide)
            {
                for(let i = 0 ; i <  p_seating_chart.m_cart_items_infos.length;++i)
                {
                    carts_ids_used.push(i);
                }
            }
            else
            {
                for(let i = 0 ; i < cart_items_id.length;++i)
                {
                    carts_ids_used.push(cart_items_id[i]);
                }
            }

            p_seating_chart.m_mode_extensions_handler.m_current_edit_mode.m_callback = [];
            p_seating_chart.m_mode_extensions_handler.m_current_edit_mode.m_callback.push((e)=>{this.UpdateSeatInfo()})
            p_seating_chart.m_mode_extensions_handler.m_current_edit_mode.SetSeatWithConcretizedID();

            let respond = p_seating_chart.m_mode_extensions_handler.m_current_edit_mode.SetParameters(product_we_are_looking_for,amount_of_seat_we_are_looking_for,carts_ids_used);
            if(!respond)
            {
                alert("NO Seat Available With your current Ticket set-up");
                return;
            }

            //than relaunch the Seating_chart_find_ticket_setup
            p_seating_chart.m_mode_extensions_handler.m_current_edit_mode.Setup();
            //just update seating chart lod
            p_seating_chart.m_lod_system_handler.StartLODSystem(true);
        },
        valid_next_btn()
        {
            let valid = true;
            for (const [idx, item] of Object.entries(this.$root.cart_products_seating_chart)) {

                if(!isset(this.$root.seating_place_info[idx]))
                {
                    valid = false;
                }

            }

            if(valid === true)
            {
                this.$root.disabled_next_btn = false;
            }
            else
            {
                this.$root.disabled_next_btn = true;
            }

        },

        init()
        {
            this.$root.disabled_next_btn = true;
            this.$root.current_event_is_loaded = this.$root.arrayRemove(this.$root.current_event_is_loaded,'loading-seating');


        },

        ResetZoomSeatingChart()
        {
            window.seating_chart_info['seating_chart_app'].m_camera_handler.BackGroundStageZoom();
        },
        MoveSeatingChart(p_x,p_y)
        {
            window.seating_chart_info['seating_chart_app'].m_camera_handler.CameraIsMovingForce(p_x,p_y)
        },
        ZoomSeatingChart(p_z)
        {

            window.seating_chart_info['seating_chart_app'].m_camera_handler.CameraZoomForce(p_z);

        },


    },


    props: {
        locale: String,
        section: String,
    },

    setup() {

    },

}
</script>

<style scoped>

</style>
